var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelf2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 35,
    viewBox: "0 0 44 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.75C0 6.33691 1.97313 4.375 4.4 4.375H39.6C42.0269 4.375 44 6.33691 44 8.75V26.25C44 28.6631 42.0269 30.625 39.6 30.625H4.4C1.97313 30.625 0 28.6631 0 26.25V8.75ZM22 8.75V26.25H39.6V8.75H22ZM12.2581 12.0244C12.0381 11.5322 11.5431 11.2109 11 11.2109C10.4569 11.2109 9.96187 11.5322 9.74187 12.0244L5.34188 21.8682C5.0325 22.5586 5.34875 23.3652 6.04313 23.6729C6.7375 23.9805 7.54875 23.666 7.85813 22.9756L8.47 21.6016H13.53L14.1419 22.9756C14.4513 23.666 15.2625 23.9736 15.9569 23.6729C16.6513 23.3721 16.9606 22.5586 16.6581 21.8682L12.2581 12.0244ZM11 15.9414L12.3063 18.8672H9.69375L11 15.9414ZM30.8 11.2109C31.5563 11.2109 32.175 11.8262 32.175 12.5781V12.8516H36.3C37.0563 12.8516 37.675 13.4668 37.675 14.2188C37.675 14.9707 37.0563 15.5859 36.3 15.5859H36.1625L36.0525 15.8936C35.4406 17.5615 34.5125 19.0791 33.33 20.3643C33.3919 20.4053 33.4538 20.4395 33.5156 20.4736L34.815 21.2461C35.4681 21.6357 35.6744 22.4766 35.2894 23.1191C34.9044 23.7617 34.0519 23.9736 33.4056 23.5908L32.1063 22.8184C31.7969 22.6338 31.5013 22.4424 31.2056 22.2373C30.4769 22.75 29.7 23.1943 28.8681 23.5635L28.6206 23.6729C27.9263 23.9805 27.115 23.666 26.8056 22.9756C26.4963 22.2852 26.8125 21.4785 27.5069 21.1709L27.7544 21.0615C28.1944 20.8633 28.6206 20.6445 29.0263 20.3916L28.1875 19.5576C27.6513 19.0244 27.6513 18.1562 28.1875 17.623C28.7238 17.0898 29.5969 17.0898 30.1331 17.623L31.1369 18.6211L31.1712 18.6553C32.0238 17.7598 32.7181 16.7207 33.22 15.5791L30.8 15.5859H25.85C25.0938 15.5859 24.475 14.9707 24.475 14.2188C24.475 13.4668 25.0938 12.8516 25.85 12.8516H29.425V12.5781C29.425 11.8262 30.0438 11.2109 30.8 11.2109Z",
    fill: "url(#paint0_linear_1681_4208)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1681_4208",
    x1: 0.00000104374,
    y1: 1.09375,
    x2: 23.6073,
    y2: 44.4348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6EB5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelf2);
export default __webpack_public_path__ + "static/media/Self2.d8b97030b63bb48ebf38de8fd0fd793c.svg";
export { ForwardRef as ReactComponent };